import { render, staticRenderFns } from "./GroupViewGroupInfoCard.vue?vue&type=template&id=979bb78a"
import script from "./GroupViewGroupInfoCard.vue?vue&type=script&lang=js"
export * from "./GroupViewGroupInfoCard.vue?vue&type=script&lang=js"
import style0 from "./GroupViewGroupInfoCard.vue?vue&type=style&index=0&id=979bb78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports